






import Vue from 'vue'

export default Vue.extend({
  name: 'CircleArrowIcon',

  props: {
    /* down, left, right */
    direction: {
      type: String,
      default: 'right',
    },
  },
})
